import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@/shared/components/MaterialTableElements';

const rows = [
    { id: 'name', label: 'Name', disablePadding: true },
    { id: 'targetType', label: 'Target' },
    { id: 'targetTitle', label: 'Target Title' },
    { id: 'cadence', label: 'Cadence' },
    { id: 'time', label: 'Time (UTC)' },
    { id: 'nextPublishAt', label: 'Next Publish' },
    { id: 'queueDepth', label: 'Queue' },
    { id: 'enabled', label: 'Enabled' },
];

interface Props {
    onRequestSort: (event: unknown, property: string) => void;
    order: 'asc' | 'desc';
    orderBy: string;
}

const MatTableHead = ({ order, orderBy, onRequestSort }: Props) => {
    const rtl = useSelector((state: { rtl: { direction: 'ltr' | 'rtl' } }) => state.rtl);
    return (
        <TableHead>
            <TableRow>
                {rows.map((row) => (
                    <TableCell
                        key={row.id}
                        align={rtl.direction === 'rtl' ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === row.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={(e: unknown) => onRequestSort(e, row.id)}
                            className="material-table__sort-label"
                            dir="ltr"
                        >
                            {row.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
